import { createApp } from "vue";
import { createPinia } from "pinia";
import PrimeVue from "primevue/config";
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
import Tooltip from "primevue/tooltip";
import Aura from "@primevue/themes/aura";
import VueKonva from "vue-konva";

import App from "./App.vue";
import { router } from "./router";

import "primeicons/primeicons.css";
import "./style.css";

const app = createApp(App);

app.use(createPinia());
app.use(router);

app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      prefix: "p",
      darkModeSelector: ".dark",
      cssLayer: {
        name: "primevue",
        // Tailwind utility classes override PrimeVue styles where needed
        order: "tailwind-base, primevue, tailwind-utilities",
      },
    },
  },
  ripple: false, // we do our own micro-interactions
});

app.use(ToastService);
app.use(ConfirmationService);
app.directive("tooltip", Tooltip);

// Register vue-konva globally — this gives us <v-stage>, <v-layer>, <v-image>, etc.
app.use(VueKonva);

app.mount("#app");
